function starfireTrapFocus(container, elementToFocus) {
  if (window.theme && theme.a11y && theme.a11y.trapFocus) {
    theme.a11y.trapFocus({
      container: container,
      elementToFocus: elementToFocus || container,
      namespace: 'cfp-modal'
    });
    return;
  }
  (elementToFocus || container).focus();
}

var STARFIRE_DUMMY_CFP_PRICE = 9999900;

function starfireIsCfpVariant(variant, cfpIds) {
  if (!variant) return false;
  if (Array.isArray(cfpIds) && cfpIds.indexOf(variant.id) !== -1) return true;
  return Number(variant.price) >= STARFIRE_DUMMY_CFP_PRICE;
}

function starfireApplyCfpPrice(variant, cfpIds) {
  var priceEl = document.querySelector('[data-product-price]');
  if (!priceEl || !variant) return;

  var label = priceEl.getAttribute('data-cfp-price-label');
  if (!label) return;

  var isCfp = starfireIsCfpVariant(variant, cfpIds);
  var compareWrap = document.querySelector('[data-product-price-wrap]');
  var savePrice = document.querySelector('[data-save-price]');

  if (isCfp) {
    priceEl.textContent = label;
    priceEl.classList.add('product__price--cfp');
    priceEl.classList.remove('on-sale');
    if (compareWrap) compareWrap.classList.add('hide');
    if (savePrice) savePrice.classList.add('hide');
  } else {
    priceEl.classList.remove('product__price--cfp');
  }
}

function starfireRemoveTrapFocus(elementToFocus) {
  if (window.theme && theme.a11y && theme.a11y.removeTrapFocus) {
    theme.a11y.removeTrapFocus({
      container: document.querySelector('cfp-modal'),
      namespace: 'cfp-modal'
    });
  }
  if (elementToFocus) elementToFocus.focus();
}

if(!customElements.get('cfp-modal')) {
  customElements.define(
    'cfp-modal',
    class CFPModal extends HTMLElement {
      constructor() {
        super();

        this.cfpIds = this.dataset.cfpIds.split(',').map(el => parseInt(el));
        this.closeEls = this.querySelectorAll('.cfp-modal__close');

        this.closeEls.forEach(el => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            this.hide();
          });
        });

        this.addEventListener('keyup', (e) => {
          if(e.code && e.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        this.addEventListener('click', (e) => {
          if(e.target === this) this.hide();
        });

        document.addEventListener('variant:change', this.onVariantChange.bind(this));
      }
      connectedCallback() {
        if(this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
        
        this.querySelector('.cfp-modal__form-container').append(this.querySelector('template').content.cloneNode(true));
      }

      show(opener) {
        this.openedBy = opener;
        document.body.classList.add('cfp-modal--open');
        this.setAttribute('open', '');
        document.body.dispatchEvent(new CustomEvent('cfpModalOpened'));
        starfireTrapFocus(this, this.querySelector('[role="dialog"]'));
      }
      hide() {
        document.body.classList.remove('cfp-modal--open');
        document.body.dispatchEvent(new CustomEvent('cfpModalClosed'));
        this.removeAttribute('open');
        starfireRemoveTrapFocus(this.openedBy);
      }
      onVariantChange(e) {
        if(!e.detail?.variant) return;
        const variantId = e.detail.variant.id;

        const productNameEl = this.querySelector('[data-cfp-name]');
        if(productNameEl) productNameEl.value = e.detail.variant.name;
        
        const productLinkEl = this.querySelector('[data-cfp-link]');
        if(productLinkEl) productLinkEl.value = productLinkEl.value.replace(/\?variant=\d+/, `?variant=${variantId}`);
        
        const productAdminLink = this.querySelector('[data-cfp-link-admin]');
        if(productAdminLink) productAdminLink.value = productAdminLink.value.replace(/\/variants\/\d+/, `/variants/${variantId}`);
        
        var paymentButtons = document.querySelector('.original-payment-buttons');
        if (paymentButtons) paymentButtons.classList.toggle('hide', this.cfpIds.includes(variantId));
        starfireApplyCfpPrice(e.detail.variant, this.cfpIds);
        requestAnimationFrame(function() {
          starfireApplyCfpPrice(e.detail.variant, this.cfpIds);
        }.bind(this));
      }
    }
  );
}
if(!customElements.get('cfp-modal-opener')) {
  customElements.define(
    'cfp-modal-opener',
    class CFPModalOpener extends HTMLElement {
      constructor() {
        super();

        this.buttonEl = this.querySelector('button');
        this.modalEl = document.querySelector(this.dataset.modal);
        this.cfpIds = this.dataset.cfpIds.split(',').map(el => parseInt(el));

        if(!this.buttonEl || !this.modalEl) return;
        this.buttonEl.addEventListener('click', (e) => {
          this.modalEl.show(this.buttonEl);
        });
        
        document.addEventListener('variant:change', this.onVariantChange.bind(this));
      }
      onVariantChange(e) {
        if(!e.detail?.variant) return;
        this.classList.toggle('hide', !this.cfpIds.includes(e.detail.variant.id));
      }
      disconnectedCallback() {
        this.modalEl.remove();
      }
    }
  );
}
